import React from "react";

import { CartProductOptions } from "./CartProductOptions";
import { CartProductQuantity } from "./CartProductQuantity";
import { mobileBreakpoint } from "../../../../../entrypoints/theme";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const CartStackedProduct = ({ item, settings }) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const showVariantOptions = true;

  if (!item) {
    return false;
  }

  const size = item.options_with_values.find(
    (option) => option.name.toLowerCase() === "fragrance",
  );

  const line_item_price = item.price / 100;
  const show_total_price = true;
  // @ts-ignore
  const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
  const currencyCode =  window.Alpine?.store('currency').getCurrencyCode();
  let totalDiscount = 0;
  if (item.discounts) {
    item.discounts.forEach((discount) => {
      totalDiscount += discount.amount;
    });
  }

  let optionsClass = "h4";
  let priceClass = "h4";

  if (isMobile) {
    optionsClass = "h6";
    priceClass = "h6";
  }

  return (
    <>
      <div className="cart__item w-full flex max-lg:flex-col gap-4">
        <div className="flex gap-4 w-full">
          <a href={item.url} className="w-[76px] h-auto lg:w-[91px] shrink-0">
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </a>

          <div className="product-details lg:flex-col w-full max-lg:grow">
            <div
              data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
              className="cart__item--remove lg:hidden"
            >
              <i className="icon icon-close text-[8px] cursor-pointer"></i>
            </div>
            <div className="product-details__inner">
              <div className={`product-details__inner-top`}>
                <div className="flex justify-between">
                  <a href={item.url} className="product-title h4">
                    {item.product_title}
                  </a>

                  <div
                    data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
                    className="cart__item--remove hidden lg:block"
                  >
                    <i className="icon icon-close text-[12px] cursor-pointer"></i>
                  </div>
                </div>

                <div className="flex lg:justify-between items-center">
                  {showVariantOptions && (
                    <div className={`product-options ${optionsClass} hidden lg:flex`}>
                      {CartProductOptions(item.options_with_values)}
                    </div>
                  )}

                  <div>
                    <CartProductQuantity item={item} settings={settings} />
                  </div>

                  <div className={`product-price hidden lg:block ${priceClass}`}>
                    <div className={"flex justify-end"}>
                      <div className={"flex flex-cols"}>
                        {!show_total_price ? (
                            <>
                              <p className={`cart__item-price font-normal`}>

                                {currencyCode}{currencySymbol + line_item_price.toFixed(0)}
                              </p>
                              {item.product?.compare_at_price > 0 && (
                                <p className={`cart__item-price--compare font-normal line-through`}>
                                  {currencyCode}{currencySymbol + item.product?.compare_at_price / 100}
                                </p>
                              )}
                            </>
                        ) : (
                            <div className={'flex flex-col text-right'}>
                              {item.product?.compare_at_price && item.discounts.length <= 0 && (
                                  <p className={`cart__item-price--compare font-normal line-through`}>
                                    {currencyCode}{currencySymbol}
                                    {
                                      ((item.product?.compare_at_price * item.quantity) / 100).toFixed(0)
                                    }
                                  </p>
                              )}
                              {!item.product?.compare_at_price && item.discounts.length > 0 && (
                                  <p className={`cart__item-price--compare font-normal line-through`}>
                                    {currencyCode}
                                    {currencySymbol}
                                    {(item.original_line_price  * item.quantity / 100)}
                                  </p>
                              )}
                               <p className={`cart__item-price font-normal`}>
                                {currencyCode}
                                {currencySymbol + (line_item_price * item.quantity).toFixed(
                                    0,
                                )}
                              </p>
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="flex errors b4 my-0"
                  style={{ padding: 0 }}
                  data-ajax-cart-errors={`${item.key}`}
                ></div>
              </div>

              {/* {size && (
                <div className={"brs mt-1"}>{size?.value}</div>
              )} */}

              <div className={`product-details__inner-info`}>
                {item.selling_plan_allocation && (
                  <div className="product-selling-plan brs flex gap-1 mt-2 max-lg:items-center">


                    <span>{item.selling_plan_allocation.selling_plan.name}</span>
                  </div>
                )}

                <div className={'discounts_applied'}>
                  {item.discounts.map((discount, id) => {
                    return (
                        <React.Fragment key={id}>
                          <p className={"brs text-[#394E47]"}>
                            {discount.title}</p>
                        </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {isMobile && (
          <div className={`product-details__lower ${optionsClass}`}>
            {showVariantOptions && (
              <>
                {CartProductOptions(item.options_with_values)}
              </>
            )}
            {!show_total_price ? (
              <div>
                {item.product?.compare_at_price > 0 && (
                  <p className={`cart__item-price--compare font-normal line-through`}>
                    {currencyCode}{currencySymbol + (item.product?.compare_at_price / 100).toFixed(0)}
                  </p>
                )}
                <p className={`cart__item-price font-normal`}>
                  {currencyCode}{currencySymbol + line_item_price.toFixed(0)}
                </p>
              </div>
            ) : (
              <div className={'flex flex-col text-right'}>
                {item.product?.compare_at_price && item.discounts.length <= 0 && (
                    <p className={`cart__item-price--compare font-normal line-through`}>
                      {currencyCode}
                      {currencySymbol}
                      {
                        ((item.product?.compare_at_price * item.quantity) / 100).toFixed(0)
                      }
                    </p>
                )}
                {!item.product?.compare_at_price && item.discounts.length > 0 && (
                    <p className={`cart__item-price--compare font-normal line-through`}>
                      {currencyCode}
                      {currencySymbol}
                      {(item.original_line_price  / 100).toFixed(0)}
                    </p>
                )}
                <p className={`cart__item-price font-normal`}>
                  {currencyCode}
                  {currencySymbol + (line_item_price).toFixed(0)}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
